
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { PasscodeToContinueOptions } from "@/model/pagePartOptions/PasscodeToContinueOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";

    @Component({})
    export default class PasscodeToContinuePart extends Vue {

        @Prop({ default: new PasscodeToContinueOptions() })
        options!: PasscodeToContinueOptions;

        @Prop({ required: true })
        answer!: VisitAnswer;

        @Prop({ default: false })
        isAdminView!: boolean;

        isError = false;

        get length() {
            return this.options.passcode.length;
        }

        get style(): Record<string, any> {
            return {
                "width": `${this.options.passcode.length * 60}px`
            };
        }

        onTextInput(text: string) {
            this.isError = text.toLowerCase() !== this.options.passcode.toLowerCase();
            //console.log("PASSCODE - onTextInput = ", text);
            this.$emit("answer-changed", -1, this.answer.pagePartID, text);
        }
    }
